export enum SubscriptionURI {
  BaseV2 = '/v2/subscriptions',
  Extension = '/extension/subscription',

  ChangeBillingAccount = '/change-billing-account',
  Planned = '/planned'
}

export enum PlanCode {
  BetaPlan = 'sme_ch',
  SmeFree = 'sme_free_ch',
  Essential = 'essential_ch',
  Grow = 'grow_ch',
  Business = 'business_ch',
  Enterprise = 'enterprise_ch'
}

export enum BillingInterval {
  Monthly = 'IntervalMonthly',
  Yearly = 'IntervalYearly'
}

export enum PlanFees {
  FeeATMDomesticCHF = 'FeeATMDomesticCHF',
  FeeATMDomesticEUR = 'FeeATMDomesticEUR',
  FeeATMInternational = 'FeeATMInternational',
  FeeCardIssuing = 'FeeCardIssuing',
  FeeCardUsage = 'FeeCardUsage',
  FeeDomesticAccountUsage = 'FeeDomesticAccountUsage',
  FeeDomesticPayment = 'FeeDomesticPayment',
  FeeInternationalPaymentSEPAIn = 'FeeInternationalPaymentSEPAIn',
  FeeInternationalPaymentSEPAOut = 'FeeInternationalPaymentSEPAOut',
  FeeInternationalPaymentSWIFTIn = 'FeeInternationalPaymentSWIFTIn',
  FeeInternationalPaymentSWIFTOut = 'FeeInternationalPaymentSWIFTOut',
  FeeNegativeInterest = 'FeeNegativeInterest',
  FeePay4Value = 'FeePay4Value',
  FeeReplacementCard = 'FeeReplacementCard',
  FeeSupportCase = 'FeeSupportCase',
  FeeVirtualCardUsage = 'FeeVirtualCardUsage',
  FeeWiseTransfer = 'FeeWiseTransfer',
  FeeYapiniMonthlyOverview = 'FeeYapiniMonthlyOverview',
  FeeYapiniPocketMoney = 'FeeYapiniPocketMoney',
  FeeYapiniSendMoney = 'FeeYapiniSendMoney',
}

export enum PlanFeatures {
  Feature3aPension = 'Feature3aPension',
  FeatureATMDomesticCHF = 'FeatureATMDomesticCHF',
  FeatureATMDomesticEUR = 'FeatureATMDomesticEUR',
  FeatureATMInternational = 'FeatureATMInternational',
  FeatureApplePay = 'FeatureApplePay',
  FeatureCardProgram = 'FeatureCardProgram',
  FeatureDomesticAccount = 'FeatureDomesticAccount',
  FeatureDomesticPayment = 'FeatureDomesticPayment',
  FeatureEBill = 'FeatureEBill',
  FeatureGooglePay = 'FeatureGooglePay',
  FeatureInboundPayment = 'FeatureInboundPayment',
  FeatureInternationalPaymentSEPAIn = 'FeatureInternationalPaymentSEPAIn',
  FeatureInternationalPaymentSEPAOut = 'FeatureInternationalPaymentSEPAOut',
  FeatureInternationalPaymentSWIFTIn = 'FeatureInternationalPaymentSWIFTIn',
  FeatureInternationalPaymentSWIFTOut = 'FeatureInternationalPaymentSWIFTOut',
  FeatureJoinIncentiveProgram = 'FeatureJoinIncentiveProgram',
  FeatureLaunchIncentivePrograms = 'FeatureLaunchIncentivePrograms',
  FeaturePersonalisedIBAN = 'FeaturePersonalisedIBAN',
  FeatureRelais = 'FeatureRelais',
  FeatureSamsungPay = 'FeatureSamsungPay',
  FeatureSubmitExpenses = 'FeatureSubmitExpenses',
  FeatureVirtualCard = 'FeatureVirtualCard',
  FeatureVisaDebitCard = 'FeatureVisaDebitCard',
  FeatureWise = 'FeatureWise',
  FeatureYapiniInvite = 'FeatureYapiniInvite',
  FeatureYapster2YapsterPayment = 'FeatureYapster2YapsterPayment'
}

interface MonthlyFeatureDetails {
  uid: string;
  status: 'new' | 'active' | 'cancelled';
  linkedEntityUid: string;
  toCancel: boolean;
  dateSubscribed: string;
  dateActivated: string;
  featureType: PlanFeatures;
}

export interface Subscription {
  uid: string;
  status: SubscriptionStatus;
  current: SubscriptionDetails;
  planned?: SubscriptionDetails;
  lockUid: string;
  processingDate: string;
  nextBillingDate: string;
  lastBillingDate: string;
  billingDay: number;
  monthlyProcessingDate: string;
  nextMonthlyBillingDate: string;
  lastMonthlyBillingDate: string;
  monthlyFeatureDetails: MonthlyFeatureDetails[];
  consumablesUsed: { [key in PlanFeatures]: number };
}

interface SubscriptionDetails {
  activationDate: string;
  billingAccountUid: string;
  billingInterval: BillingInterval;
  passiveDate: string;
  planCode: PlanCode;
  planUid: string;
  requestingAgentUid: string;
  voucherFreeDays?: number;
}

export enum SubscriptionStatus {
  New = 'new',
  Active = 'active',
  Passive = 'passive',
  Cancelled = 'cancelled',
  Suspended = 'suspended',
  Retired = 'retired'
}
